import { useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function SupportSessionBanner() {
  const { supportSession } = useAuth();
  const [detailsVisible, setDetailsVisible] = useState(false);
  if (!supportSession) return null;

  const operator = supportSession.actorType === "AI"
    ? supportSession.agentName || "IA de testing"
    : supportSession.actorEmail;

  return (
    <div
      className="fixed right-0 top-[72dvh] z-[1000] -translate-y-1/2"
      onMouseEnter={() => setDetailsVisible(true)}
      onMouseLeave={() => setDetailsVisible(false)}
      onFocusCapture={() => setDetailsVisible(true)}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node | null)) setDetailsVisible(false);
      }}
      onKeyDown={(event) => {
        if (event.key === "Escape") setDetailsVisible(false);
      }}
    >
      <button
        type="button"
        aria-label="Ver detalles de la sesión delegada"
        aria-describedby={detailsVisible ? "support-session-details" : undefined}
        aria-expanded={detailsVisible}
        onClick={() => setDetailsVisible((visible) => !visible)}
        className="group inline-flex h-12 w-7 items-center justify-center rounded-l-2xl border border-r-0 border-gray-200 bg-white shadow-[0_4px_14px_rgba(15,23,42,0.14)] transition hover:w-8 hover:bg-amber-50 focus-visible:w-8 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300 focus-visible:ring-offset-2"
      >
        <span className="size-3 rounded-full bg-amber-400 shadow-[0_0_0_4px_rgba(251,191,36,0.18)] transition group-hover:scale-110" />
      </button>

      <div
        className={`absolute right-full top-1/2 w-[min(320px,calc(100vw-48px))] -translate-y-1/2 pr-2 transition duration-150 ${
          detailsVisible
            ? "pointer-events-auto translate-x-0 opacity-100"
            : "pointer-events-none translate-x-2 opacity-0"
        }`}
      >
        <div
          id="support-session-details"
          role="tooltip"
          className="overflow-hidden rounded-2xl border border-amber-200 bg-white shadow-[0_16px_40px_rgba(15,23,42,0.18)]"
        >
          <div className="flex items-center gap-2 border-b border-amber-100 bg-amber-50 px-4 py-3">
            <span className="size-2.5 shrink-0 rounded-full bg-amber-400" />
            <span className="text-sm font-semibold text-gray-950">
              Sesión delegada de {supportSession.mode === "READ_ONLY" ? "solo lectura" : "testing"}
            </span>
          </div>
          <dl className="space-y-2 px-4 py-3 text-xs leading-5">
            <div className="grid grid-cols-[72px_minmax(0,1fr)] gap-2">
              <dt className="font-medium text-gray-400">Operador</dt>
              <dd className="truncate font-semibold text-gray-700">{operator}</dd>
            </div>
            <div className="grid grid-cols-[72px_minmax(0,1fr)] gap-2">
              <dt className="font-medium text-gray-400">Cuenta</dt>
              <dd className="break-all font-semibold text-gray-700">{supportSession.targetEmail}</dd>
            </div>
            <div className="grid grid-cols-[72px_minmax(0,1fr)] gap-2">
              <dt className="font-medium text-gray-400">Vence</dt>
              <dd className="font-semibold text-gray-700">
                {new Date(supportSession.expiresAt).toLocaleString("es-CO")}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
